<template>
  <div>TODO</div>
</template>

<script>
import store from '@/store/store';

export default {
  beforeMount() {
    store.commit('authStudent/setActiveExperienceID', this.$route.params.id);
  },
};
</script>
